import { render, staticRenderFns } from "./SignatureFranchise.vue?vue&type=template&id=07b31dc4&"
import script from "./SignatureFranchise.vue?vue&type=script&lang=js&"
export * from "./SignatureFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports